<template>
  <section class="py-3">
    <div v-if="userRewards && userRewards.length">
      <div v-for="(userReward, index) in userRewards" :key="index">
        <router-link :to="`/user-rewards/${userReward.id}`" class="no-style">
          <div class="card">
            <div class="card-body p-3">
              <div class="d-flex align-items-top">
                <div class="pr-3">
                  <img class="rounded" height="72" :src="userReward.reward.image_url">
                </div>
                <div class="flex-fill">
                  <div>
                    <span class="badge text-badge-small badge-pill py-1 px-2"
                          :class="getUserRewardStatus(userReward).cssClass">
                      {{ getUserRewardStatus(userReward).text }}
                    </span>
                  </div>
                  <div class="pt-2">
                    <b>{{ ($i18n.locale === 'th') ? userReward.reward.title_th : userReward.reward.title_en }}</b>
                  </div>
                  <div class="pt-2 text-secondary text-remark" v-if="userReward.expire_date">
                    {{ $t('message.rewards.expired_on') }} {{ userReward.expire_date | prettyOnlyDate }}
                  </div>
                </div>
              </div>
              <div class="text-right" v-if="userReward.reward.delivery_info_type && !userReward.delivery_info">
                <router-link class="btn btn-outline-info btn-sm" :to="`/user-rewards/${userReward.id}/delivery-info`">
                  {{ $t('message.rewards.add_delivery_info') }}
                </router-link>
              </div>
            </div>
          </div>
        </router-link>
      </div>
      <div class="text-center" v-if="canLoadMore">
        <button class="btn btn-block btn-info"
                :disabled="isLoadingMore"
                @click="fetchMore()"
                v-if="isMore">
          {{ isLoadingMore ? $t('message.button.loading') : $t('message.button.load_more') }}
        </button>
      </div>
    </div>
    <div class="p-4 row text-center" v-else>
      <loader v-if="isLoading"></loader>
      <div class="col-12" v-else>
        <h3>
          <i class="fas fa-exclamation-triangle -status-pending"></i>
          {{ $t('message.rewards.no_redeemed_reward_remark') }}
        </h3>
      </div>
    </div>
  </section>
</template>


<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import moment from 'moment-timezone'
  import userRewardHelpers from '../../helpers/userRewardHelpers'
  import Loader from '../loader/Loader'

  export default {
    props: {
      currentTab: String
    },
    components: {
      Loader
    },
    data () {
      return {
        queryParams: {
          page: 0,
          user_id: null,
          tab_name: 'isActive'
        },
        canLoadMore: false,
        isLoading: false,
        isLoadingMore: false
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      }),
      ...mapState('userReward', ['userRewards', 'isMore'])
    },
    watch: {
      currentTab () {
        this.fetchFirst()
      }
    },
    methods: {
      ...mapActions('userReward', ['fetchUserRewards']),
      getUserRewardStatus (userReward) {
        return userRewardHelpers.getUserRewardStatus(userReward)
      },
      isExpired (userReward) {
        const currentDate = moment().format('YYYY-MM-DD')
        return currentDate > userReward.expire_date
      },
      async fetchMore () {
        this.isLoadingMore = true
        this.queryParams.page += 1
        await this.fetchUserRewards(this.queryParams)
        this.isLoadingMore = false
      },
      async fetchFirst () {
        this.queryParams.page = 0
        this.queryParams.user_id = this.user.id
        this.queryParams.tab_name = this.currentTab
        this.isLoading = true
        const data = await this.fetchUserRewards(this.queryParams)
        if (data && !data.error) {
          this.canLoadMore = data.user_rewards.length >= data.limit
        }
        this.isLoading = false
      }
    },
    mounted () {
      this.fetchFirst()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/reward/UserRewards.vue